import Modal from '../../Utilities/Modal'

const ClearQuestionsModal = ({ open, setOpen, clearQuestions }) => {
  return (
    <Modal
      title="Clear All Questions"
      open={open}
      setOpen={setOpen}
      confirmFunction={() => {
        clearQuestions()
        setOpen(false)
      }}
      size="md"
    >
      <p>This will remove all questions from the Q&A list.</p>
      <p>Messages will remain in Chat History</p>
    </Modal>
  )
}

export default ClearQuestionsModal
